export function contextoMovimento(search, empresaId, pessoaId) {
    const p = new URLSearchParams(search);
    return JSON.stringify([empresaId || '', pessoaId || '', ...['operacao','li','natureza','origem'].map(k => p.get(k) || '')]);
}
export function parametrosConferencia(li, origem, modo) {
    return { menuSubId: li, origem: origem || '', classificacaoConferencia: modo };
}
